import React from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language || "en";
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
  };

  return (
    <div
      className="lang-switcher"
      role="tablist"
      aria-label="Language switcher"
    >
      <button
        className={`lang-btn ${current === "en" ? "active" : ""}`}
        onClick={() => changeLanguage("en")}
        aria-pressed={current === "en"}
        aria-label="English"
        title="English"
      >
        <span className="label">EN</span>
      </button>

      <button
        className={`lang-btn ${current === "uk" ? "active" : ""}`}
        onClick={() => changeLanguage("uk")}
        aria-pressed={current === "uk"}
        aria-label="Українська"
        title="Українська"
      >
        <span className="label">UA</span>
      </button>
    </div>
  );
}

export default LanguageSwitcher;
